import React from "react";
import PropTypes from "prop-types";
import * as PaymentWallet from "../PaymentWallet";

const DynamicImportComponent = props => {
  const Component = PaymentWallet[props.component].component;
  return <div>{Component && <Component />}</div>;
};

DynamicImportComponent.propTypes = {
  component: PropTypes.string.required,
};

export default DynamicImportComponent;



// WEBPACK FOOTER //
// ./src/component/DynamicImportComponent/index.js